import './modal.scss';

import nodeMarquee from 'node-marquee';
import axios from 'axios';
import { createElementFromHTML } from './../../utilities/js/helper';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class Modal {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-modal',
            strapAttr: 'data-modalstrap',
            onAjaxLoaded: null,
            onClosed: null,
            loader: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.modalType = 'content';
        this.strapAnimation = null;
        this.sessionIsActive = sessionStorage.getItem('session_is_active') === null;

        this.$modal = element;
        this.$strap = null;

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$modal.addEventListener('click', (e) => {
            e.preventDefault();
            this.openModal();
        });

        if (this.$modal.getAttribute('data-modal-open') !== null || (this.$modal.getAttribute('data-modal-open-session') !== null && this.sessionIsActive)) {
            window.setTimeout(() => {
                this.openModal();
            }, 500);
        }
    }

    buildStrap () {
        this.strapAnimation = nodeMarquee({
            parent: this.$strap,
            speed: 0.4
        });
    }

    openModal () {
        const modalId = this.$modal.getAttribute('data-modal');
        this.$modalTarget = document.getElementById(modalId);

        this.$modalParent = this.$modalTarget.parentNode;
        document.body.appendChild(this.$modalTarget);

        this.$strap = this.$modalTarget.querySelector(`[${this.settings.strapAttr}]`);

        if (this.$strap) {
            this.buildStrap();
        }

        const $currentModal = document.querySelector('.modal.is--active');
        if ($currentModal) {
            const modalAPI = $currentModal.API;
            modalAPI.closeModal();
        }

        if (this.$modalTarget === null) {
            const uri = this.$modal.getAttribute('href');
            this.modalType = 'ajax';

            if (uri !== null) {
                this.loadModal(uri, () => {
                    this.showModal();
                });
            }
        } else {
            this.showModal();
        }
    }

    loadModal (uri, callback) {
        let $loader = null;

        if (this.settings.loader !== null) {
            $loader = createElementFromHTML(this.settings.loader);
        }

        if ($loader !== null) {
            this.$modal.appendChild($loader);
        }

        axios({
            url: uri
        })
            .then((response) => {
                if (typeof response.data.action !== 'undefined' && typeof response.data.content !== 'undefined' && response.data.action === 'render') {
                    const content = response.data.content;
                    const $content = createElementFromHTML(content);
                    document.querySelector('body').appendChild($content);
                    const modalId = $content.getAttribute('id');
                    this.$modalTarget = document.getElementById(modalId);

                    if ($loader !== null) {
                        $loader.parentNode.removeChild($loader);
                    }

                    if (typeof this.settings.onAjaxLoaded === 'function') {
                        this.settings.onAjaxLoaded(this.$modalTarget);
                    }

                    if (typeof callback === 'function') {
                        callback();
                    }
                }
            })
            .catch((error) => {
                throw Error(error);
            });
    }

    showModal () {
        if (this.modalType === 'ajax') {
            window.setTimeout(() => {
                this.$modalTarget.classList.add('is--active');
            }, 250);
        } else {
            this.$modalTarget.classList.add('is--active');
        }

        const $$exists = this.$modalTarget.querySelectorAll('.modal__exit');
        $$exists.forEach(($exit) => {
            $exit.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeModal();
            });
        });

        this.$modalTarget.API = this;
        disableBodyScroll(this.$modalTarget);
    }

    closeModal () {
        window.setTimeout(() => {
            this.$modalTarget.classList.remove('is--active');
        }, 250);

        if (this.modalType === 'ajax') {
            window.setTimeout(() => {
                document.body.removeChild(this.$modalTarget);
            }, 250);
        } else {
            this.$modalParent.appendChild(this.$modalTarget);
        }

        if (typeof this.settings.onClosed === 'function') {
            this.settings.onClosed(this.$modalTarget);
        }

        enableBodyScroll(this.$modalTarget);

        // If modal visibility is session-specific, save an marker in sessionStorage to identify the session
        if (this.$modal.getAttribute('data-modal-open-session') !== null) {
            sessionStorage.setItem('session_is_active', '');
        }
    }
}

export { Modal };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$modal = $context.querySelectorAll('[data-modal]');
        for (let i = 0; i < $$modal.length; i++) {
            const $modal = $$modal[i];

            const modalAPI = new Modal($modal);
            $modal.API = modalAPI;
        }
    }
});
